export enum AdCampaigns {
  GOOGLE = "gclid",
  FACEBOOK = "fbclid",
  MICROSOFT = "msclkid",
}
